export default __webpack_public_path__ + "static/media/pharmacy.32ff00a3.jpg";